import { IStatisticMetrics, IStatistic } from './base-statistics';

export interface IOrganisationStats extends IStatisticMetrics {
  // Aggregate Facts
  costs: IStatistic;
  revenue: IStatistic;
  revenueKPI: IStatistic;
}
